
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliates-program",
      function () {
        return require("private-next-pages/affiliates-program/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliates-program"])
      });
    }
  